import script from "./ManageTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageTeam.vue?vue&type=script&setup=true&lang=ts"

import "./ManageTeam.vue?vue&type=style&index=0&id=cee1c924&lang=scss"

const __exports__ = script;

export default __exports__